<button *ngIf="language$ | async as language" class="button button--lined button--menu button--menu--start language-selector"
        (click)="toggle()"
        title="{{title(language)}}">
  <span class="{{smallClass()}}">A</span><span class="{{largeClass()}} with-zoom">A</span>
</button>
